import { render, staticRenderFns } from "./IntelligentAmplifier.vue?vue&type=template&id=4b5b7336&scoped=true&"
import script from "./IntelligentAmplifier.vue?vue&type=script&lang=js&"
export * from "./IntelligentAmplifier.vue?vue&type=script&lang=js&"
import style0 from "./IntelligentAmplifier.vue?vue&type=style&index=0&id=4b5b7336&lang=scss&scoped=true&"
import style1 from "./IntelligentAmplifier.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b7336",
  null
  
)

export default component.exports